module.exports = "/assets/data/3afa5f2dcc437ddfb32183602a5b9fe1-ME8.data.json";